import { render } from "./OfficesView.vue?vue&type=template&id=51d8db29"
import script from "./OfficesView.vue?vue&type=script&lang=js"
export * from "./OfficesView.vue?vue&type=script&lang=js"

import "./OfficesView.vue?vue&type=style&index=0&id=51d8db29&lang=scss"

import exportComponent from "/home/runner/work/pmanastacio/pmanastacio/apps/anastacio_site/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__